export const disableBrowserBackButton = (url: string) => {
    window.history.pushState(null, '', url);
    window.addEventListener('popstate', function (event){
        if(window.location.href === url) {
            window.history.pushState(null, '',  window.location.pathname);
        }
    });
}
